import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=f557fb4c&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f557fb4c')) {
      api.createRecord('f557fb4c', component.options)
    } else {
      api.reload('f557fb4c', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=f557fb4c&", function () {
      api.rerender('f557fb4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/annual-return/edit.vue"
export default component.exports